import React from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';

function CustomNoRowsOverlay(props) {
  return (
    <div
      role="presentation"
      className="ag-overlay-loading-center no-record-found-msg"
      style={{ height: '9%' }}
    >
      <span>No data found.</span>
    </div>
  );
};

const mapStateToProps = (globalState) => {
  return {

  };
}

export default connect(mapStateToProps)(withNamespaces()(CustomNoRowsOverlay));